<script lang="ts">
    import {_} from 'svelte-i18n'
    import {myPendingConversations, paths} from './services';
</script>


{#if $myPendingConversations.length > 0}
    <a href={$paths.home}>
        {$_('user.session.XOfPendings', {values: {x: $myPendingConversations.length}})}
    </a>
{/if}